import { WorkspaceList } from 'src/context/api/workspaces/models';

// Métriques Shopping / PMax du catalogue KPI (metrics.csv). Leur affichage est conditionné
// au remplissage des listes de campagnes du workspace (google_ads.branded_shopping_campaigns
// / branded_pmax_campaigns) : sans campagne configurée, la métrique n'a pas de donnée
// exploitable et ne doit apparaître nulle part (Overview, Funnel, Explore).
export const SHOPPING_METRIC_IDS = [
    'shopping_brand_traffic',
    'shopping_paid_ctr',
    'shopping_cpc',
    'shopping_ad_cost',
];

export const PMAX_METRIC_IDS = [
    'pmax_brand_traffic',
    'pmax_ctr',
    'pmax_cpc',
    'pmax_ad_cost',
];

export interface BrandedCampaignsVisibility {
    showShopping: boolean;
    showPmax: boolean;
}

// Les champs gads_* viennent de GET /workspaces/ (liste → currentWorkspace en Redux).
export const brandedCampaignsVisibility = (
    workspace?: Pick<WorkspaceList, 'gads_branded_shopping_campaigns' | 'gads_branded_pmax_campaigns'> | null
): BrandedCampaignsVisibility => ({
    showShopping: (workspace?.gads_branded_shopping_campaigns?.length ?? 0) > 0,
    showPmax: (workspace?.gads_branded_pmax_campaigns?.length ?? 0) > 0,
});

export const isMetricAllowed = (id: string, visibility: BrandedCampaignsVisibility) => {
    if (!visibility.showShopping && SHOPPING_METRIC_IDS.includes(id)) return false;
    if (!visibility.showPmax && PMAX_METRIC_IDS.includes(id)) return false;
    return true;
};
